import React from 'react'

export const NotificationBell = ({ color, height, width }) => (
  <svg width={width} height={height} viewBox='0 0 21.357 26.947'>
    <g transform='translate(-53.014 0)'>
      <path
        fill={color}
        d='M184.9,465.044a4.071,4.071,0,0,0,7.451,0Z'
        transform='translate(-124.938 -440.528)'
      />
      <path
        fill={color}
        d='M199.4,2.575a9.156,9.156,0,0,1,3.126.548V3a3.005,3.005,0,0,0-3-3h-.249a3.005,3.005,0,0,0-3,3v.119A9.174,9.174,0,0,1,199.4,2.575Z'
        transform='translate(-135.711)'
      />
      <path
        fill={color}
        d='M73.559,97.614H53.825A.8.8,0,0,1,53.032,97a.767.767,0,0,1,.422-.873,4.188,4.188,0,0,0,1.274-1.732,20.017,20.017,0,0,0,1.329-7.921,7.635,7.635,0,0,1,15.269-.03c0,.01,0,.02,0,.03a20.017,20.017,0,0,0,1.329,7.921,4.187,4.187,0,0,0,1.274,1.732.767.767,0,0,1,.422.873A.8.8,0,0,1,73.559,97.614Zm.38-1.484h0Z'
        transform='translate(0 -74.68)'
      />
    </g>
  </svg>
)

NotificationBell.defaultProps = {
  color: '#212121',
  height: 27,
  width: 21
}
